import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./ProductDetail.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { URL } from "../Redux/common/url";
import BgImage from "../images/acfan.jpg";
export default function ProductDetail() {
 const { id } = useParams();
  const [post, setpost] = useState({});
  const [FaqShow, setFaqShow] = useState(0);
  const [donorShow, setdonorShow] = useState(0);
  const [postVer, setpostVer] = useState([]);
  const [recentDonor, setrecentDonor] = useState([]);
  const [topDonor, settopDonor] = useState([]);
  const feturesdata = post?.features ? JSON.parse(post?.features) : [];

  console.log(post);

  const navigate = useNavigate();
  const recivedPr =
    post?.recivedAmount > 0
      ? (post?.recivedAmount / post?.afterdiscountprice) * 100
      : 0;

  console.log(post);
  console.log(postVer);

  const [valuesetUserDeatils, setUserDeatils] = useState({});

  console.log(valuesetUserDeatils);

  useEffect(() => {
    if (typeof window !== "undefined") {
      //   setValue(localStorage.getItem("access_token"));
      //   setValuevendor(localStorage.getItem("access_token_vendor"));

      const userDetails = localStorage.getItem("access_user");
      // if (!userDetails) {
      //   navigate("/login");
      // }
      // setUserDeatils(JSON?.parse(userDetails));
    } else {
      //   setValue("");
      //   setValuevendor("");
      setUserDeatils({});
    }
  }, []);

  const proDetailsCon = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const bgl = await fetch(
      URL.API_BASE_URL + `${URL.productDetails}/${id}`,
      requestOptions
    );
    // const bgl2 = await fetch(
    //   URL.API_BASE_URL + `${URL.recentDonors}`,
    //   requestOptions
    // );

    const events = await bgl.json();
    // const events1 = await bgl2.json();

    const postData = events?.data;
    // const postData1 = events1?.data;

    // console.log(postData1);

    // setrecentDonor(postData1?.recent ?? []);
    // settopDonor(postData1?.top ?? []);
    setpostVer(postData?.subcolor ?? []);

    const prV = postData?.subcolor?.length > 0 ? postData?.subcolor : [];
    setpost(postData);
    console.log(postData);

    const prv2 = prV?.map((data, i) => {
      return {
        // ...data,
        color: data?.color,
        _id: data?._id,
        images: data?.images[0]?.img,
        // productsize: data?.productsize,
        productId: data?.productId,
        sizeId: data?.productsize[0]?._id,
        size: data?.productsize[0]?.size,
        price: data?.productsize[0]?.price,
        item: 0,
        afterdiscountprice: data?.productsize[0]?.afterdiscountprice,
        collected: data?.productsize[0]?.collected,
        stock: data?.productsize[0]?.stock,
      };
    });
    console.log(prV);

    setpostVer(prv2 ?? []);
  };

  useEffect(() => {
    proDetailsCon();

    return () => {};
  }, [id]);

  const [DonationData, setDonationData] = useState({ amount: "3000" });
  // Determine the width and height based on screen width
 const [play, setPlay] = useState(false);
  const hendleToChange = (e) => {
    setDonationData({ ...DonationData, [e.target.name]: e.target.value });

    if (e.target.name == "amount") {
      // const totalAmount = postVer.reduce(
      //   (acc, item) => acc + item.item * item.afterdiscountprice,
      //   0
      // );
      // setDonationData({ ...DonationData, ["amount"]: totalAmount });
      const newPostVer = [...postVer];
      newPostVer.forEach((item) => (item.item = 0));
      setpostVer(newPostVer);
    }
  };
  const hendleToChange2 = (name, value) => {
    setDonationData({ ...DonationData, [name]: value });

    if (name == "amount") {
      // const totalAmount = postVer.reduce(
      //   (acc, item) => acc + item.item * item.afterdiscountprice,
      //   0
      // );
      // setDonationData({ ...DonationData, ["amount"]: totalAmount });
      const newPostVer = [...postVer];
      newPostVer.forEach((item) => (item.item = 0));
      setpostVer(newPostVer);
    }
  };
  const hendleToChangeinc = (e) => {
    console.log(e);
    const newPostVer = [...postVer];
    newPostVer[e].item = newPostVer[e].item + 1;
    setpostVer(newPostVer);
    console.log(newPostVer);
    const totalAmount = newPostVer.reduce(
      (acc, item) => acc + item.item * item.afterdiscountprice,
      0
    );
    setDonationData({ ...DonationData, ["amount"]: totalAmount });
    // setDonationData({ ...DonationData, [e.target.name]: e.target.value });

    // setDonationData({ ...DonationData, [e.target.name]: e.target.value });
  };
  const hendleToChangedec = (e) => {
    console.log(e);
    const newPostVer = [...postVer];
    newPostVer[e].item = newPostVer[e].item - 1;
    setpostVer(newPostVer);
    const totalAmount = newPostVer.reduce(
      (acc, item) => acc + item.item * item.afterdiscountprice,
      0
    );
    console.log(newPostVer);
    setDonationData({ ...DonationData, ["amount"]: totalAmount });
  };

  const hendleToSubmit = async (e) => {
    e.preventDefault();
    // donationTypeDetails

    // if (!DonationData?.father_name) {
    //   toast?.error("Please enter father name");
    //   return;
    // }
    // if (!DonationData?.volunteer) {
    //   toast?.error("Please select volunteer");
    //   return;
    // }
    if (!DonationData?.amount) {
      toast?.error("Please enter amount");
      return;
    }

    DonationData.district = valuesetUserDeatils?.district;
    DonationData.city = valuesetUserDeatils?.city;
    DonationData.user_mobile = valuesetUserDeatils?.phone;
    DonationData.user_name = valuesetUserDeatils?.fullName;
    DonationData.state = valuesetUserDeatils?.state;
    DonationData.pincode = valuesetUserDeatils?.zip;
    DonationData.amount =
      typeof DonationData?.amount == "string"
        ? parseInt(DonationData?.amount)
        : DonationData?.amount;
    DonationData.donationId = post?._id;

    const verri = postVer?.filter((data) => data?.item > 0);
    DonationData.otherItems = verri;
    // DonationData.otherItems = JSON.stringify(verri);

    const lsValue = JSON.stringify(DonationData);
    localStorage.setItem("check_out", lsValue);
    navigate("/checkout");
    // DonationData.donation_id = details?._id;
    // checkoutHandler(
    //   valuesetUserDeatils?.fullName,
    //   DonationData.amount,

    //   valuesetUserDeatils?.phone,
    //   valuesetUserDeatils?.email
    // );
    // checkoutHandler(
    //   valuesetUserDeatils?.fullName,
    //   DonationData.amount,
    //   valuesetUserDeatils?.phone,
    //   valuesetUserDeatils?.email
    // );
    // const response = await dispatch(
    //   allapiAction.createOrderDonate(DonationData)
    // );

    // if (response?.success) {
    //   // navigate("/");
    //   setDonationData({
    //     address: "",
    //     amount: "",
    //     pancardno: "",
    //     father_name: "",
    //   });
    //   proDetailsCon();
    // }
  };
  const checkoutHandler = async ({ name, amount, phone, email }) => {
    const token = await localStorage.getItem("access_token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    DonationData.district = valuesetUserDeatils?.district;
    DonationData.city = valuesetUserDeatils?.city;
    DonationData.user_mobile = valuesetUserDeatils?.phone;
    DonationData.user_name = valuesetUserDeatils?.fullName;
    DonationData.state = valuesetUserDeatils?.state;
    DonationData.pincode = valuesetUserDeatils?.zip;
    DonationData.donation_id = post?._id;
    const verri = postVer?.filter((data) => data?.item > 0);
    DonationData.otherItems = JSON.stringify(verri);
    const {
      data: { order },
    } = await axios.post(
      URL.API_BASE_URL + "/sellerApi/Checkoutdonation",
      DonationData,
      config
    );

    console.log(order);

    // rzp_test_fa1tcuhWuZinSi
    // rzp_test_Wfjgw9yyFXbDbN
    const options = {
      key: "rzp_test_Wfjgw9yyFXbDbN", // Enter the Key ID generated from the Dashboard
      amount: order.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: "INR",
      name: "Payment razorpay",
      description: "Test Transaction",
      image: "https://example.com/your_logo",
      order_id: order.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1

    
      callback_url: `${URL.API_BASE_URL}/publicApi/verification2`,
      prefill: {
        name: name,
        email: valuesetUserDeatils?.email,
        contact: valuesetUserDeatils?.phone,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };

   
    const rzp1 = new window.Razorpay(options);

    rzp1.open();
  };
  const [userData, setUserData] = useState({});
        const [aadhaarFile, setAadhaarFile] = useState(null);
    
      
        const handleChange = (e) => {
          const { name, value } = e.target;
          setUserData({ ...userData, [name]: value });
        };
      
        const handleFileChange = (e) => {
          setAadhaarFile(e.target.files[0]);
        };
      
        const handleSubmit = async (e) => {
          e.preventDefault();
          const formData = new FormData();
      
          Object.entries(userData).forEach(([key, value]) => {
            formData.append(key, value);
          });
      
        
          try {
            const response = await fetch("https://api.solarclubbharat.com/publicApi/createContact", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(userData),
            });
            const data = await response.json();
      
            if (response.ok) {
        alert(data.message || "Enquiry submitted successfully!");
       
      }  else {
              toast.error(data.message || "Registration failed");
            }
          } catch (error) {
            toast.error("Something went wrong.");
          }
        }; 
  return (
   <div>
  {/* Breadcrumbs only */}
<nav aria-label="breadcrumb" className="mb-4" style={{ position: 'relative', top: '70px' }}>
  <ol className="breadcrumb custom-breadcrumb shadow-sm p-3 rounded-3">
    <li className="breadcrumb-item">
      <a href="/" className="text-decoration-none">🏠 Home</a>
    </li>
    <li className="breadcrumb-item">
      <a href="/products" className="text-decoration-none">Products</a>
    </li>
    <li className="breadcrumb-item active fw-bold" aria-current="page">{post?.title}</li>
  </ol>
</nav>

  <div className="container py-5">
    <div className="row bg-white shadow-lg rounded-4 overflow-hidden">

      {/* Left Side - Product Image */}
      <div className="col-md-6 p-4 d-flex flex-column align-items-center bg-light">
        <img
          src={URL?.API_BASE_URL + post?.featureImage}
          className="img-fluid rounded-4 shadow-lg main-product-img"
          alt={post?.title}
        />
      </div>

      {/* Right Side - Product Details */}
      <div className="col-md-6 p-5 bg-gradient-custom text-white">
        <h1 className="fw-bold mb-3">{post?.title}</h1>
        <p className="lead">{post?.short_description}</p>

        <div
          dangerouslySetInnerHTML={{ __html: post?.description }}
        ></div>

        {/* Enquiry Button */}
        <button
          className="btn btn-lg enquiry-btn px-5 py-3 fw-bold"
          data-bs-toggle="modal"
          data-bs-target="#enquiryModal"
        >
          🚀 Enquire Now
        </button>

        {/* Share Buttons */}
        <div className="mt-4 d-flex gap-3 flex-wrap">
          <a
            href={`https://wa.me/?text=${encodeURIComponent(
              post?.title + " - " + post?.short_description + " " + window.location.href
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-success btn-sm"
          >
            <i className="fab fa-whatsapp me-2"></i> Share on WhatsApp
          </a>

          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary btn-sm"
          >
            <i className="fab fa-facebook-f me-2"></i> Share on Facebook
          </a>
        </div>
      </div>
    </div>

    {/* Enquiry Modal */}
    <div
      className="modal fade"
      id="enquiryModal"
      tabIndex="-1"
      aria-labelledby="enquiryModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content enquiry-modal">
          <div className="modal-header border-0">
            <h5 className="modal-title fw-bold text-white" id="enquiryModalLabel">
              🔴 Send Enquiry
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="mb-3">
                <input type="text" className="form-control form-control-lg enquiry-input" placeholder="Your Name" name="name" onChange={handleChange} />
              </div>
              <div className="mb-3">
                <input type="email" className="form-control form-control-lg enquiry-input" placeholder="Your Email" name="email" onChange={handleChange} />
              </div>
              <div className="mb-3">
                <input type="tel" className="form-control form-control-lg enquiry-input" placeholder="Your Phone Number" name="mobile" onChange={handleChange} />
              </div>
              <div className="mb-3">
                <input type="text" className="form-control form-control-lg enquiry-input" placeholder="Your City" name="address" onChange={handleChange} />
              </div>
            </form>
          </div>
          <div className="modal-footer border-0">
            <button type="button" className="btn btn-outline-light" data-bs-dismiss="modal">
              ❌ Cancel
            </button>
            <button type="submit" className="btn btn-danger px-4 fw-bold" onClick={handleSubmit}>
              ✅ Submit Enquiry
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  );
}
